import { render, staticRenderFns } from "./RotateSquare3.vue?vue&type=template&id=ce5a5b92&scoped=true&"
import script from "./RotateSquare3.vue?vue&type=script&lang=js&"
export * from "./RotateSquare3.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare3.vue?vue&type=style&index=0&id=ce5a5b92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5a5b92",
  null
  
)

export default component.exports